<template>
  <section class="about-hero" id="identification">
    <div class="about-hero__inner">
      <div class="about-hero__media">
        <!-- Imagen para desktop/tablet -->
        <img
          class="about-hero__img about-hero__img--desktop"
          src="@/assets/IMG/hombre-pulsera.png"
          alt="Hombre con pulsera"
        />
        <!-- Imagen para móvil -->
        <img
          class="about-hero__img about-hero__img--mobile"
          src="@/assets/IMG/hombre_movil.png"
          alt="Hombre con pulsera móvil"
        />
      </div>

      <div class="about-hero__copy">
        <h1 class="about-hero__title">
          SEGURIDAD<br />
          QUE ENTRENA<br />
          CONTIGO
        </h1>

        <p class="about-hero__text">
          Somos una marca enfocada en prevención y seguridad. Creamos una pulsera
          inteligente que combina diseño minimalista con tecnología NFC y código QR
          para almacenar información médica esencial y datos relevantes del
          deportista.
          <br /><br />
          No es solo un accesorio deportivo. Es una herramienta de emergencia.
          <br />
          <strong>Pensada para actuar cuando tú no puedes hacerlo.</strong>
        </p>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "AboutHero",
};
</script>

<style scoped>
.about-hero {
  position: relative;
  width: 100vw;
  left: 50%;
  transform: translateX(-50%);
  background: #111;
  overflow: hidden;
  padding: 20px 0 0;
}

.about-hero__inner {
  width: min(1320px, 94%);
  margin: 0 auto;
  min-height: 720px;
  display: grid;
  grid-template-columns: 0.9fr 1.1fr;
  align-items: stretch;
  gap: clamp(28px, 4vw, 72px);
}

/* LEFT */
.about-hero__media {
  position: relative;
  min-height: 720px;
  height: 100%;
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  overflow: visible;
}

.about-hero__img {
  position: absolute;
  left: -320px;
  bottom: -12px;
  width: min(720px, 54vw);
  max-width: none;
  height: auto;
  object-fit: contain;
  object-position: right bottom;
  z-index: 2;
  filter: drop-shadow(0 18px 34px rgba(0, 0, 0, 0.28));
  pointer-events: none;
  user-select: none;
}

.about-hero__img--mobile {
  display: none;
}

.about-hero__img--desktop {
  display: block;
}

/* RIGHT */
.about-hero__copy {
  max-width: 760px;
  align-self: center;
  padding-right: 8px;
  padding-bottom: 28px;
}

.about-hero__title {
  margin: 0 0 18px;
  font-family: "Barlow Condensed", "Barlow", Arial, sans-serif;
  font-size: clamp(58px, 6vw, 102px);
  font-weight: 700;
  line-height: 0.9;
  letter-spacing: -0.02em;
  text-transform: uppercase;
  color: #c8f34b;
}

.about-hero__text {
  margin: 0;
  max-width: 690px;
  font-family: Arial, Helvetica, sans-serif;
  font-size: clamp(19px, 1.75vw, 30px);
  line-height: 1.07;
  color: #ffffff;
}

.about-hero__text strong {
  font-weight: 800;
  color: #ffffff;
}

/* ===== DESKTOP MEDIO ===== */
@media (max-width: 1200px) {
  .about-hero__inner {
    min-height: 650px;
    grid-template-columns: 0.88fr 1.12fr;
    gap: 32px;
  }

  .about-hero__media {
    min-height: 650px;
  }

  .about-hero__img {
    left: -180px;
    bottom: 0;
    width: min(620px, 48vw);
  }

  .about-hero__title {
    font-size: clamp(50px, 5.7vw, 84px);
    line-height: 0.91;
  }

  .about-hero__text {
    font-size: clamp(17px, 1.6vw, 24px);
    line-height: 1.12;
  }
}

/* ===== TABLET GENERAL: SIEMPRE 2 COLUMNAS ===== */
@media (min-width: 601px) and (max-width: 1024px) {
  .about-hero {
    padding: 28px 0 0;
  }

  .about-hero__inner {
    width: min(94%, 960px);
    min-height: 560px;
    grid-template-columns: 0.95fr 1.05fr;
    align-items: stretch;
    gap: 22px;
  }

  .about-hero__media {
    min-height: 520px;
    height: 100%;
    justify-content: flex-end;
    align-items: flex-end;
  }

  .about-hero__img {
    position: absolute;
    left: -70px;
    bottom: 0;
    width: min(470px, 46vw);
    max-width: none;
    transform: none;
  }

  .about-hero__copy {
    text-align: left;
    padding-right: 0;
    padding-bottom: 18px;
    max-width: 100%;
    align-self: center;
  }

  .about-hero__title {
    font-size: clamp(38px, 4.8vw, 62px);
    line-height: 0.93;
    letter-spacing: -0.015em;
    margin-bottom: 14px;
  }

  .about-hero__text {
    max-width: 100%;
    font-size: clamp(15px, 1.8vw, 21px);
    line-height: 1.18;
  }
}

/* ===== iPad Mini / 768 x 1024 ===== */
@media (width: 768px) and (height: 1024px) {
  .about-hero__inner {
    width: min(94%, 720px);
    min-height: 560px;
    grid-template-columns: 0.92fr 1.08fr;
    gap: 18px;
  }

  .about-hero__media {
    min-height: 500px;
  }

  .about-hero__img {
    left: -95px;
    bottom: 0;
    width: 430px;
    transform: none;
  }

  .about-hero__title {
    font-size: 42px;
  }

  .about-hero__text {
    font-size: 15.5px;
    line-height: 1.2;
  }
}

/* ===== iPad Air / 820 x 1180 ===== */
@media (width: 820px) and (height: 1180px) {
  .about-hero__inner {
    width: min(94%, 770px);
    min-height: 620px;
    grid-template-columns: 0.94fr 1.06fr;
    gap: 20px;
  }

  .about-hero__media {
    min-height: 560px;
  }

  .about-hero__img {
    left: -110px;
    bottom: 0;
    width: 470px;
    transform: none;
  }

  .about-hero__title {
    font-size: 46px;
  }

  .about-hero__text {
    font-size: 16px;
    line-height: 1.2;
  }
}

/* ===== iPad Pro 12.9 / 1024 x 1366 ===== */
@media (width: 1024px) and (height: 1366px) {
  .about-hero__inner {
    width: min(94%, 940px);
    min-height: 700px;
    grid-template-columns: 0.95fr 1.05fr;
    gap: 26px;
  }

  .about-hero__media {
    min-height: 660px;
  }

  .about-hero__img {
    left: -140px;
    bottom: 0;
    width: 560px;
    transform: none;
  }

  .about-hero__title {
    font-size: 56px;
  }

  .about-hero__text {
    font-size: 18px;
    line-height: 1.18;
  }
}

/* ===== Surface Pro / similares ===== */
@media (min-width: 900px) and (max-width: 1024px) and (min-height: 1200px) {
  .about-hero__inner {
    width: min(94%, 900px);
    min-height: 660px;
    gap: 24px;
  }

  .about-hero__img {
    left: -120px;
    bottom: 0;
    width: 520px;
    transform: none;
  }

  .about-hero__title {
    font-size: 52px;
  }

  .about-hero__text {
    font-size: 17px;
  }
}

/* ===== MÓVIL: TEXTO ARRIBA / IMAGEN ABAJO ===== */
@media (max-width: 600px) {
  .about-hero {
    padding: 20px 0 0;
  }

  .about-hero__inner {
    width: min(92%, 420px);
    min-height: auto;
    grid-template-columns: 1fr;
    gap: 10px;
  }

  .about-hero__copy {
    order: 1;
    text-align: center;
    padding-right: 0;
    padding-bottom: 0;
    max-width: 100%;
  }

  .about-hero__title {
    font-size: clamp(30px, 9vw, 46px);
    line-height: 0.93;
    letter-spacing: -0.015em;
    margin-bottom: 12px;
  }

  .about-hero__text {
    max-width: 100%;
    font-size: clamp(14px, 4vw, 17px);
    line-height: 1.2;
    text-align: center;
  }

  .about-hero__media {
    order: 2;
    min-height: 300px;
    height: 300px;
    justify-content: center;
    align-items: flex-end;
  }

  .about-hero__img--desktop {
    display: none !important;
  }

  .about-hero__img--mobile {
    display: block !important;
    position: absolute;
    left: 50% !important;
    right: auto !important;
    bottom: -50px;
    transform: translateX(-50%);
    width: min(320px, 84vw);
    max-width: 372px;
  }
}

/* ===== 414 - 430 ===== */
@media (min-width: 414px) and (max-width: 430px) {
  .about-hero__media {
    min-height: 320px;
    height: 320px;
  }

  .about-hero__img--mobile {
    width: min(340px, 86vw);
    bottom: -50px;
    left: 50% !important;
    transform: translateX(-50%);
  }

  .about-hero__title {
    font-size: clamp(32px, 8.6vw, 46px);
  }
}

/* ===== CELULAR PEQUEÑO ===== */
@media (max-width: 390px) {
  .about-hero__media {
    min-height: 270px;
    height: 270px;
  }

  .about-hero__img--mobile {
    width: min(290px, 84vw);
    bottom: -44px;
    left: 50% !important;
    transform: translateX(-50%);
  }

  .about-hero__title {
    font-size: clamp(28px, 8.8vw, 40px);
    line-height: 0.94;
  }

  .about-hero__text {
    font-size: 13.2px;
    line-height: 1.22;
  }
}
</style>